var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('b-card',[_c('h1',{staticClass:"mb-0"},[_vm._v("Dashboard User")])])],1)],1),_c('campaigns-statistics'),_c('websites-visitors')],1)}
var staticRenderFns = []

export { render, staticRenderFns }